import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../api/axiosInstance";

// Base URL
const BASE_URL = "/api/v1/locations";

// Async Thunks
export const fetchLocations = createAsyncThunk(
  "locations/fetchAll",
  async () => {
    try {
      const res = await axios.get(BASE_URL);
      console.log("responce of locations", res);
      return res.data.data;
    } catch (error) {
      console.log("::error::", error);
    }
  }
);

export const fetchLocationById = createAsyncThunk(
  "locations/fetchById",
  async (id) => {
    const res = await axios.get(`${BASE_URL}/${id}`);
    return res.data.data;
  }
);

export const createLocation = createAsyncThunk(
  "locations/create",
  async (formData, { rejectWithValue }) => {
    try {
       console.log(":::location slice form data::")
      for (let pair of formData.entries()) {
      
        console.log(`${pair[0]}:`, pair[1]);
      
      }
      console.log(":::location slice is called:::")
      const res = await axios.post(`${BASE_URL}`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      return res.data.data;
    } catch (error) {
      console.error("Create location failed:", error);

      let message = "Failed to create location.";
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        message = error.response.data.message;
      }

      return rejectWithValue(message);
    }
  }
);

export const updateLocation = createAsyncThunk(
  "locations/update",
  async ({ id, data }, thunkAPI) => {
    try {
      const res = await axios.put(`${BASE_URL}/${id}`, data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      return res.data.data;
    } catch (error) {
      // Extract a meaningful error message
      let message;
      if (error.response && error.response.data) {
        message =
          error.response.data.message || error.response.data.error || "Update failed";
      } else {
        message = error.message || "Something went wrong";
      }

      // Return a rejected action with the error message
      return thunkAPI.rejectWithValue(message);
    }
  }
)

export const deleteLocation = createAsyncThunk(
  "locations/delete",
  async (id) => {
    await axios.delete(`${BASE_URL}/${id}`);
    return id;
  }
);

// Slice
const locationSlice = createSlice({
  name: "locations",
  initialState: {
    locations: [],
    currentLocation: null,
    loading: false,
    error: null,
  },
  reducers: {
    clearCurrentLocation(state) {
      state.currentLocation = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchLocations.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchLocations.fulfilled, (state, action) => {
        state.loading = false;
        state.locations = action.payload;
      })
      .addCase(fetchLocations.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(fetchLocationById.fulfilled, (state, action) => {
        state.currentLocation = action.payload;
      })

      .addCase(createLocation.fulfilled, (state, action) => {
        state.locations.push(action.payload);
      })

      .addCase(updateLocation.fulfilled, (state, action) => {
        const index = state.locations.findIndex(
          (loc) => loc._id === action.payload._id
        );
        if (index !== -1) {
          state.locations[index] = action.payload;
        }
        state.currentLocation = action.payload;
      })

      .addCase(deleteLocation.fulfilled, (state, action) => {
        state.locations = state.locations.filter(
          (loc) => loc._id !== action.payload
        );
      });
  },
});

export const { clearCurrentLocation } = locationSlice.actions;
export default locationSlice.reducer;
